import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutDetentionSummary } from "./autogen/AutogenLayoutDetentionSummary";
import { Navigation, UrlUtil } from "@mcleod/core";

export class DetentionSummary extends AutogenLayoutDetentionSummary {

    sourceDetentionHistoryLookupAfterExecution(event: DataSourceExecutionEvent) {
        this.populateTotals(event.dataSource.summaryData ?? null);
    }

    populateTotals(summary) {
        if (!summary) return;
        this.textboxDetentionCount.text = summary.getNumber("summary_count", 0).toString();
        this.textboxChargeCount.text = summary.getNumber("summary_charge_count", 0).toString();
        this.textboxChargeTotal.text = summary.getCurrency("summary_charge_total", 0).toString(true);
        this.textboxAverageCharge.text = summary.getCurrency("summary_charge_average", 0).toString(true);    
    }

    public setNewTabFilter(filter: any) {
        if (!this.buttonViewInNewTab.visible) {
            this.buttonViewInNewTab.visible = true;
        }
        if (filter.creation_date) {
            const dates = filter.creation_date.split("&").map(d => d.trim().substring(2));
            this.textboxDateRange.visible = true;
            this.textboxDateRange.text = `${dates[0]} - ${dates[1]}`;
        }
        this.buttonViewInNewTab.addClickListener( _ => 
            Navigation.navigateTo(`lme/dispatch/DetentionHistoryList${UrlUtil.buildQueryString(filter)}`, { newTab: true } )
        );
    }
}